(() => {
  'use strict';

  const initializeProductGallery = () => {
    document.querySelectorAll('.product-gallery:not(.init)').forEach((gallery) => {
      gallery.classList.add('init');

      const main = new Splide(gallery.querySelector('.main-splide'), {
        start: Number(gallery.dataset.start),
        rewind: true,
        arrows: false,
        rewindByDrag: true,
        pagination: false,
        noDrag: 'model-viewer',
        mediaQuery: 'min',
        breakpoints: {
          0: { padding: { right: gallery.dataset.showThumbsMobile === 'false' ? '4rem' : 0 } },
          992: { padding: 0 },
        },
        direction: document.documentElement.getAttribute('dir'),
      });

      const slides = [...gallery.querySelectorAll('.main-splide .splide__slide')];
      const videos = [...gallery.querySelectorAll('video')];
      const loadImage = (image) => {
        if (!image?.dataset.src) return;
        image.src = image.dataset.src;
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        delete image.dataset.src;
        delete image.dataset.srcset;
      };
      const loadVideo = (video) => {
        if (!video || video.getAttribute('src') || !video.dataset.src) return;
        video.src = video.dataset.src;
        video.load();
      };
      const hydrateThumbnails = () => {
        gallery.querySelectorAll('.thumbs-splide img[data-src]').forEach(loadImage);
      };
      const thumbnails = gallery.querySelector('.thumbs-splide');
      thumbnails?.addEventListener('pointerdown', hydrateThumbnails, { once: true, passive: true });
      thumbnails?.addEventListener('focusin', hydrateThumbnails, { once: true });
      const activateMedia = (index) => {
        const slide = slides[index];
        if (!slide) return;
        loadImage(slide.querySelector('img[data-src]'));
        videos.forEach((video) => video.pause());
        const video = slide.querySelector('video');
        if (!video) return;
        loadVideo(video);
        if (gallery.dataset.videoAutoplay === 'true') video.play().catch(() => {});
      };

      const thumbsRoot = gallery.querySelector('.thumbs-splide');
      const thumbsTrack = thumbsRoot?.querySelector('.splide__track');
      const thumbSlides = [...(thumbsRoot?.querySelectorAll('.splide__slide') || [])];
      const sizeThumbs = () => {
        if (!thumbsTrack) return;
        const width = Math.max(56, (thumbsTrack.clientWidth - 32) / 5);
        thumbSlides.forEach((slide) => { slide.style.flex = `0 0 ${width}px`; });
      };
      const setActiveThumb = (index, scroll = true) => {
        thumbSlides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (scroll) thumbSlides[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      };
      thumbsRoot?.classList.remove('splide');
      thumbsRoot?.classList.add('v4-native-thumbs');
      sizeThumbs();
      window.addEventListener('resize', sizeThumbs, { passive: true });
      thumbSlides.forEach((slide, index) => {
        slide.setAttribute('role', 'button');
        slide.setAttribute('tabindex', '0');
        slide.addEventListener('click', () => main.go(index));
        slide.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            main.go(index);
          }
        });
      });

      main.on('mounted', () => {
        activateMedia(main.index);
        setActiveThumb(main.index, false);
      });
      main.on('move', (newIndex, prevIndex) => {
        const previousSlide = slides[prevIndex];
        const iframe = previousSlide?.querySelector('iframe');
        if (iframe) iframe.src = iframe.src;
        previousSlide?.querySelector('video')?.pause();
        activateMedia(newIndex);
        setActiveThumb(newIndex);
      });

      window.addEventListener('variantChange.shopiweb.product', (event) => {
        if (event.detail.featured_media) main.go(event.detail.featured_media.position - 1);
      });

      main.mount();

      gallery.dataset.v4GalleryReady = 'true';

      if (window.matchMedia('(min-width: 992px)').matches) {
        const navbarHeight = document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0;
        const announcementBarHeight = document.querySelector('[id*="__announcement-bar"].sticky-top')?.clientHeight || 0;
        const galleryWrapper = gallery.closest('.product-gallery-wrapper');
        if (galleryWrapper) {
          galleryWrapper.style.position = 'sticky';
          galleryWrapper.style.top = `${navbarHeight + announcementBarHeight + 20}px`;
          galleryWrapper.style.zIndex = '1';
        }
      }

      const modelViewer = gallery.querySelector('model-viewer');
      if (modelViewer) {
        const increaseBtn = gallery.querySelector('[data-model-3d-increase-zoom]');
        const decreaseBtn = gallery.querySelector('[data-model-3d-decrease-zoom]');
        const fullscreenBtn = gallery.querySelector('[data-model-3d-fullscreen]');
        increaseBtn?.addEventListener('click', () => modelViewer.zoom(1));
        decreaseBtn?.addEventListener('click', () => modelViewer.zoom(-1));
        fullscreenBtn?.addEventListener('click', () => {
          if (document.fullscreenElement) {
            document.exitFullscreen();
            fullscreenBtn.querySelector('.bi-fullscreen')?.removeAttribute('hidden');
            fullscreenBtn.querySelector('.bi-fullscreen-exit')?.setAttribute('hidden', 'hidden');
          } else {
            modelViewer.closest('.product-gallery-model-3d')?.requestFullscreen();
            fullscreenBtn.querySelector('.bi-fullscreen')?.setAttribute('hidden', 'hidden');
            fullscreenBtn.querySelector('.bi-fullscreen-exit')?.removeAttribute('hidden');
          }
        });
      }
    });
  };

  window.__V4_PRODUCT_GALLERY_CRITICAL__ = true;
  window.initializeV4ProductGallery = initializeProductGallery;
  initializeProductGallery();
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.product-gallery')) initializeProductGallery();
  });
})();
